<template>
  <div class="flex flex-col h-full w-full bg-white">
    <div class="flex flex-col justify-center px-4 py-2 w-full text-base font-medium text-gray-600">

      <div class="mb-4 text-xs font-semibold tracking-wider text-gray-400 uppercase">
        MAIN MENU
      </div>

      <div v-for="(item, index) in filteredStudentMenuItems" :key="index" @click="hideMenu">
        <SidebarMenuItem
          :routeName="item.routeName"
          :tooltipText="item.tooltipText"
          :menuText="item.menuText"
          :menuIcon="item.menuIcon"
          :isCollapsed="false"
          :isActiveRoute="isActiveRoute(item.path)"
          :school="school || null"
        />
      </div>

      <div @click="confirmLogout" class="flex gap-3 items-center px-4 py-3.5 mt-4 w-full min-h-[44px] rounded-lg cursor-pointer text-red-600 hover:bg-red-50">
        <i class="pi pi-sign-out text-lg"></i>
        <span>Log out</span>
      </div>

    </div>

    <!-- Self-contained logout dialog since this component initiates it -->
    <Dialog v-model:visible="showLogoutDialog" modal header="Confirm Logout" :style="{ width: '90vw', maxWidth: '350px' }">
        <div class="mb-4">Are you sure you want to log out?</div>
        <div class="flex justify-end gap-2">
        <button class="px-4 py-2 min-h-[44px] rounded bg-gray-200 hover:bg-gray-300" @click="showLogoutDialog = false">Cancel</button>
        <button class="px-4 py-2 min-h-[44px] rounded bg-red-600 text-white hover:bg-red-700" @click="handleLogout">Logout</button>
        </div>
    </Dialog>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '@/store/userStore';
import { useUserQuery } from '@/composables/queries/useUserQuery';
import { useToast } from 'primevue/usetoast';
import { studentMenuItems } from '@/constants/route-details.constant';
import { filterStudentMenuItems } from '@/utils/studentPortalMode';
import SidebarMenuItem from '@/components/common/SidebarMenuItem.vue';

const props = defineProps<{
  hideMenu: () => void;
}>();

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const toast = useToast();
const { school } = useUserQuery();

const showLogoutDialog = ref(false);

const isActiveRoute = (path: string) => route.path === path || route.path.startsWith(path);

const confirmLogout = () => {
  showLogoutDialog.value = true;
};

const handleLogout = async() => {
  try {
    showLogoutDialog.value = false;
    props.hideMenu();
    await userStore.logout();
    router.push({ name: 'login' });
  } catch (error) {
    toast.add({ severity: 'error', summary: 'Error', detail: error instanceof Error ? error.message : 'Error during logout', life: 3000 });
  }
};

const filteredStudentMenuItems = computed(() => filterStudentMenuItems(studentMenuItems, {
  schoolType: school.value?.school_type,
  cbtOnly: userStore.isCbtOnlyStudentPortal,
}));
</script>

<style scoped>
/* Scoped styles if needed */
</style>
